import { useFilterBarContext } from '../state/FilterBarContext';
import type {
  FilterFieldPhase,
  FilterItemConfig,
  FilterValues,
} from '../types';
import type { SelectOptionType } from '../../Controls/Select/types';

export interface UseFilterFieldResult {
  value: unknown;
  options: SelectOptionType[];
  phase: FilterFieldPhase;
  error: string | null;
  isLoading: boolean;
  config: FilterItemConfig | undefined;
  setValue: (value: unknown) => void;
  clear: () => void;
}

/**
 * Per-field accessor for use inside custom control renderers.
 * Reads from the internal FilterBar context, using only the controller's public API.
 */
export function useFilterField(name: string): UseFilterFieldResult {
  const ctx = useFilterBarContext();
  const config = ctx.itemsByName[name];
  const value = (ctx.controller.values as FilterValues)[name];

  return {
    value,
    options: ctx.controller.getOptions(name),
    phase: ctx.controller.getPhase(name),
    error: ctx.controller.getError(name),
    isLoading: ctx.controller.isLoading(name),
    config,
    setValue: (v) => ctx.controller.set(name, v),
    clear: () => ctx.controller.clear(name),
  };
}
